import { createContext } from "react";

const TasksDispatchContext = createContext();

export default TasksDispatchContext;
